declare global {
    interface Window {
        dataLayer?: unknown[];
    }
}

/** Pushes a custom event into the GTM dataLayer. No-ops if the GTM snippet (index.html) never initialized dataLayer. */
export function pushToDataLayer(event: string, data?: Record<string, unknown>): void {
    if (!window.dataLayer) return;
    window.dataLayer.push({ event, ...data });
}
